import styled, { css } from 'styled-components';
import { DashboardStatus } from './DashboardCard';
import { DESKTOP_BREAKPOINT } from '../../utils';

interface ContainerProps {
	$variant: DashboardStatus;
	$active?: boolean;
}

export const Content = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 12px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: row;
	}
`;

export const Amount = styled.span`
	display: inline-flex;
	align-items: center;
	${({ theme }) => theme.typography.headlines.h3}
`;

export const Description = styled.span`
	display: inline-flex;
	align-items: center;
	${({ theme }) => theme.typography.headlines.h6};
`;

export const Icon = styled.div`
	width: 64px;
	height: 64px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 48px;
	color: ${({ theme }) => theme.colors.neutral.white};

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		width: 48px;
		height: 48px;
		font-size: 32px;
	}
`;

export const Container = styled.div<ContainerProps>`
	padding: 24px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	border-radius: 12px;
	gap: 12px;
	cursor: pointer;
	border: ${({ theme, $active }) =>
		$active ? `1px solid ${theme.colors.primary.medium}` : 'none'};

	transition: box-shadow 0.3s;

	&:hover {
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
	}

	${({ $variant }) =>
		[
			DashboardStatus.CarsPurchased,
			DashboardStatus.ClosedOffers,
			DashboardStatus.Pending,
			DashboardStatus.ShopkeeperQty,
			DashboardStatus.GroupDealerQty,
			DashboardStatus.DealerQty,
			DashboardStatus.UserQty,
			DashboardStatus.Recused,
			DashboardStatus.Quotes

		].includes($variant) &&
		css`
			background-color: rgb(202, 131, 89, 0.15);

			${Icon} {
				background-color: ${({ theme }) => theme.colors.primary.medium};
			}

			${Content} {
				color: ${({ theme }) => theme.colors.primary.medium};
			}
		`}

	${({ $variant, theme }) =>
		[
			DashboardStatus.PaymentsPending,
			DashboardStatus.SoldOffers,
			DashboardStatus.Inactive,
			DashboardStatus.ShopkeeperInactiveQty,
			
		].includes($variant) &&
		css`
			background-color: ${theme.colors.neutral.lightRed};

			${Icon} {
				background-color: ${({ theme }) => theme.colors.neutral.red};
			}

			${Content} {
				color: ${({ theme }) => theme.colors.neutral.red};
			}
		`}

    ${({ $variant, theme }) =>
		[
			DashboardStatus.ProposalsMade,
			DashboardStatus.OpenOffers,
			DashboardStatus.PaymentsPaid,
			DashboardStatus.Active,
			DashboardStatus.ShopkeeperActiveQty,

		].includes($variant) &&
		css`
			background-color: ${theme.colors.neutral.lightGreen};

			${Icon} {
				background-color: ${({ theme }) => theme.colors.neutral.green};
			}

			${Content} {
				color: ${({ theme }) => theme.colors.neutral.green};
			}
		`}

		${({ $variant, theme }) =>
		[
			DashboardStatus.OpenQuotes,
			DashboardStatus.Quotes

			
		].includes($variant) &&
		css`
			background-color: #DEE9F2;
			

			${Icon} {
				background-color: ${({ theme }) => theme.colors.neutral.blue};
			}

			${Content} {
				color: ${({ theme }) => theme.colors.neutral.blue};
			}
		`}

		${({ $variant, theme }) =>
		[
			DashboardStatus.MadeQuotes,
			
		].includes($variant) &&
		css`
			background-color: #EEF0F2;

			${Icon} {
				background-color: #6B7588;
			}

			${Content} {
				color: #6B7588;
			}
		`}

		${({ $variant, theme }) =>
		[
			DashboardStatus.ClosedQuotes,
			
			
		].includes($variant) &&
		css`
			background-color: #F6F5E2;

			${Icon} {
				background-color: ${({ theme }) => theme.colors.neutral.yellow};
			}

			${Content} {
				color: ${({ theme }) => theme.colors.neutral.yellow};
			}
		`}

    @media (max-width: ${DESKTOP_BREAKPOINT}px) {
		padding: 12px 16px;
	}
`;
